import * as React from 'react'
import { compose, pure } from 'recompose'

import LargeTitle, { ColorType, SizeType } from '../../atoms/LargeTitle/LargeTitle'
import * as styles from './QuestionPrepare.css'

interface QuestionPrepareProps {
  children: any
}

const QuestionPrepare: React.FunctionComponent<QuestionPrepareProps> = ({ children }) => (
  <div className={styles.questionPrepare}>
    <div className={styles.questionIndex}>
      <LargeTitle size={SizeType.LARGE} color={ColorType.WHITE}>
        {children}
      </LargeTitle>
    </div>
  </div>
)

export default compose<QuestionPrepareProps, QuestionPrepareProps>(pure)(QuestionPrepare)
